import { type ReactNode, useEffect, useMemo, useRef } from 'react';
import { useShallow } from 'zustand/shallow';

import { LayerType } from 'app/modules/wallforming/components/scenes/camera-controls/types/layerType';
import { InteractionMode } from 'app/modules/wallforming/components/scenes/types/interactionMode';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import type { Group } from 'three';

interface InteractiveObjectsProps {
    children: ReactNode;
}

export const FormingScene = ({ children }: InteractiveObjectsProps) => {
    const interactionMode = usePlacementStore(useShallow((state) => state.interactionMode));
    const groupRef = useRef<Group | null>(null);

    const isInteractionEnabled = useMemo(() => interactionMode !== InteractionMode.POI_NAVIGATION, [interactionMode]);

    useEffect(() => {
        // Enable or disable raycasting for interactive objects when POI selection is active
        const layer = isInteractionEnabled ? LayerType.RAYCAST : LayerType.DEFAULT;
        const group = groupRef.current;
        if (group) {
            group.traverse((object) => {
                if (object && object.name === 'raycastable') {
                    object.layers.set(layer);
                }
            });
        }
    }, [isInteractionEnabled]);

    return (
        <group ref={groupRef} visible={isInteractionEnabled}>
            {children}
        </group>
    );
};
